import { usStates } from '@servicetitan/financing-utils-shared';
import { SelectField, SelectFieldOption } from './SelectField';
import { CSSProperties } from 'react';

interface StateSelectFieldProps {
    name: string;
    label: string;
    required?: boolean;
    disabled?: boolean;
    placeholder?: string;
    onChange?: (value: string | null) => void;
    style?: CSSProperties;
    description?: string;
    hint?: string;
    size?: 'small' | 'medium' | 'large';
}

// Convert US state abbreviations to SelectFieldOption format
const stateOptions: SelectFieldOption[] = usStates.map(state => ({
    id: state,
    label: state,
}));

export const StateSelectField = ({
    name,
    label,
    required,
    disabled,
    placeholder,
    onChange,
    description,
    hint,
    size,
    style,
}: StateSelectFieldProps) => {
    return (
        <SelectField
            name={name}
            options={stateOptions}
            label={label}
            required={required}
            disabled={disabled}
            placeholder={placeholder}
            onChange={option => onChange?.((option?.id as string) ?? null)}
            description={description}
            hint={hint}
            size={size}
            style={style}
        />
    );
};
